import PaymentReport from "./CreatePayment.jsx";

export default PaymentReport;
